import { formatInTimeZone, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
export const PARIS_TIMEZONE = 'Europe/Paris';

// Convert to Paris timezone
export const toParisTime = (date) => {
  return utcToZonedTime(new Date(date), PARIS_TIMEZONE);
};

// Get now date in Paris timezone
export const nowParisTime = () => {
  return toParisTime(new Date());
};

// Convert to Paris ISO => 2023-01-01T11:00:00.000+01:00
export const toParisISO = (date) => {
  return formatInTimeZone(date, PARIS_TIMEZONE, "yyyy-MM-dd'T'HH:mm:ssXXX");
};

// Get now date in Paris => 2023-01-01T11:00:00.000+01:00
export const nowParisISO = () => {
  return formatInTimeZone(new Date(), PARIS_TIMEZONE, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
};

// Create a date in Paris timezone from a date and a time string (HH:MM)
export const buildSlotDateTime = (baseDate, timeStr) => {
  const d = new Date(baseDate);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');

  const [h, m] = timeStr.split(':');

  const parisLocalStr = `${yyyy}-${mm}-${dd}T${h}:${m}:00`;
  return zonedTimeToUtc(parisLocalStr, PARIS_TIMEZONE);
};

// 06/02/24
export const shortDateAndYear = (date) => {
  const dateOptions = {
    timeZone: PARIS_TIMEZONE,
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  };

  return new Date(date).toLocaleDateString('fr-FR', dateOptions)
}

// Lundi 1 janvier
export const longDate = ({ date, capitalized = false }) => {
  const options = {
    timeZone: PARIS_TIMEZONE,
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  };

  let formatedDate = new Date(date).toLocaleDateString('fr-FR', options)
  if (capitalized) formatedDate = formatedDate.charAt(0).toUpperCase() + formatedDate.slice(1);

  return formatedDate;
}

// Lundi 1 janvier à 19:30
export const longDateTime = ({ date, capitalized = false }) => {
  const options = {
    timeZone: PARIS_TIMEZONE,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };

  let formatedDate =  new Date(date).toLocaleDateString('fr-FR', options)
  if (capitalized) formatedDate = formatedDate.charAt(0).toUpperCase() + formatedDate.slice(1);

  return formatedDate;
}

// 03/01/23 - 11:00 - 11:30
export const eventDate = (startTime, endTime) => {
  const dateOptions = {
    timeZone: PARIS_TIMEZONE,
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  };

  const timeOptions = {
    timeZone: PARIS_TIMEZONE,
    hour: 'numeric',
    minute: 'numeric'
  };

  return `${new Date(startTime).toLocaleDateString('fr-FR', dateOptions)}
          - ${new Date(startTime).toLocaleTimeString('fr-FR', timeOptions)}
          - ${new Date(endTime).toLocaleTimeString('fr-FR', timeOptions)}`
}

// 11:00
export const displayTime = (date) => {
  return date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const displayParisTime = (date) => {
  return formatInTimeZone(date, PARIS_TIMEZONE, 'HH:mm');
};

// 2023-01-01T11:00:00
export const shortDate = (date) => {
  const dateObj = new Date(date);
  const options = { day: 'numeric', month: 'numeric', timeZone: PARIS_TIMEZONE };
  const formattedDate = dateObj.toLocaleDateString('fr-FR', options);
  return formattedDate
}

// 30 - 45 - ...
export const minutesBetweenDates = (date1, date2) => {
  const difference = Math.abs(date2 - date1);
  const minutes = Math.floor(difference / (1000 * 60));
  return minutes;
}

export const isoDateTime = (dateTime) => {
  return formatInTimeZone(dateTime, PARIS_TIMEZONE, 'yyyy-MM-dd HH:mm:ss').replace(' ', 'T')
}

// il y a 30 minutes
export const timeSince = (dateTime) => {
  const now = new Date();
  const timeDifference = now - dateTime;
  const secondsInMs = 1000;
  const minutesInMs = secondsInMs * 60;
  const hoursInMs = minutesInMs * 60;
  const daysInMs = hoursInMs * 24;
  const weeksInMs = daysInMs * 7;
  const monthsInMs = daysInMs * 30;
  const yearsInMs = daysInMs * 365;

  if (timeDifference < secondsInMs) {
    return "à l'instant";
  } else if (timeDifference < minutesInMs) {
    const seconds = Math.floor(timeDifference / secondsInMs);
    return `il y a ${seconds} seconde${seconds > 1 ? 's' : ''}`;
  } else if (timeDifference < hoursInMs) {
    const minutes = Math.floor(timeDifference / minutesInMs);
    return `il y a ${minutes} minute${minutes > 1 ? 's' : ''}`;
  } else if (timeDifference < daysInMs) {
    const hours = Math.floor(timeDifference / hoursInMs);
    return `il y a ${hours} heure${hours > 1 ? 's' : ''}`;
  } else if (timeDifference < weeksInMs) {
    const days = Math.floor(timeDifference / daysInMs);
    return `il y a ${days} jour${days > 1 ? 's' : ''}`;
  } else if (timeDifference < monthsInMs) {
    const weeks = Math.floor(timeDifference / weeksInMs);
    return `il y a ${weeks} semaine${weeks > 1 ? 's' : ''}`;
  } else if (timeDifference < yearsInMs) {
    const months = Math.floor(timeDifference / monthsInMs);
    return `il y a ${months} mois`;
  } else {
    const day = ('0' + dateTime.getDate()).slice(-2);
    const month = ('0' + (dateTime.getMonth() + 1)).slice(-2);
    const year = dateTime.getFullYear().toString().slice(-2);
    return `le ${day}/${month}/${year}`;
  }
}

// décembre 2023
export const monthAndYear = (dateTime) => {
  const date = new Date(dateTime);
  const mois = date.toLocaleString('FR', { month: 'long' });
  const annee = date.getFullYear();

  return `${mois} ${annee}`;
}
